import React from "react";
import { LoadingButton } from "components/common/Loading";
import Button from "../Button";
import Modal from "../Modal";
import styles from "./ConfirmationDialog.module.css";

interface Props {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onAccept: () => void;
}

const ConfirmationDialog: React.FC<Props> = ({ open, loading, onClose, onAccept, children }) => {
  return (
    <Modal open={open} onRequestClose={onClose} title="Please Confirm Your Purchase">
      <div className={styles.container}>
        {children}
        <div className={styles.actionsContainer}>
          <Button theme="textButton" className={styles.actionCancel} onClick={onClose}>
            Cancel
          </Button>
          <Button theme="primary" onClick={onAccept} disabled={loading}>
            {loading ? <LoadingButton /> : "Confirm Purchase"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationDialog;
